// extracted by mini-css-extract-plugin
module.exports = {"form":"viewQuiz_form__9tXUH","addButton":"viewQuiz_addButton__1Mri6","backButton":"viewQuiz_backButton__1SaqX"};